import { PaginatedFrontendExperimentList } from '@rover/rsdk/src/apiClient/latest';

export default function FetchExperimentsResponseFactory(
  opts?: Partial<PaginatedFrontendExperimentList>
): PaginatedFrontendExperimentList {
  return {
    count: 0,
    results: [],
    ...opts,
  };
}
